import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from "react-router-dom"
import { Spinner } from "react-bootstrap"

export const LoadingSpinner = ({ show }) =>
{
    if (!show) { return <></> }

    return <Spinner variant="primary" animation="border" role="status" className="position-fixed top-50 start-50 zindex-fixed"> </Spinner>
}

export const BotaoVoltar = ({linkPrevPage, statePrevPage}) => 
{
    return (
        <Link className={"rounded-5 btn btn-primary border border-primary my-auto"} state={statePrevPage} to={linkPrevPage}>Voltar</Link>
    )
}

export const CustomTooltip = ({htmlObj, text, showIfDisabled=true}) =>
{
    return(
        <OverlayTrigger
            placement="top"
            overlay={
                <Tooltip>
                    {text}
                </Tooltip>
            }
            >
            {
                showIfDisabled?
                <span>
                    {htmlObj}
                </span>
                :
                htmlObj
            }

        </OverlayTrigger>
    )
}